<template>
  <div class="body-type-container">
    <div
      v-if="showQuestions && questions.length > 0 && step < questions.length"
    >
      <div class="question-box">
        <p class="question">
          {{ questionText }}
        </p>
        <div class="button-group">
          <button @click="answer(true)" class="next-button">예</button>
          <button @click="answer(false)" class="next-button">아니오</button>
        </div>
      </div>
    </div>
    <div v-else-if="showQuestions && finalType" class="question-box">
      <p class="result-text">당신의 체질은</p>
      <p class="result">
        <strong>{{ translatedType }}</strong>
        입니다
      </p>
    </div>
  </div>
</template>

<script>
  import { gql, GraphQLClient } from 'graphql-request'

  const apiEndpoint = import.meta.env.VITE_API_ENDPOINT
  const client = new GraphQLClient(apiEndpoint)

  const GET_SASANG_MUNJIN_QUERY = gql`
    query {
      getSasangMunjin {
        id
        question
      }
    }
  `

  const ANALYZE_SASANG_RESULT_MUTATION = gql`
    mutation analyzeSasangResult($input: AnalyzeSasangInput!) {
      analyzeSasangResult(input: $input) {
        sasang
        tie
        score
        allScores {
          taeyang
          soyang
          taeum
          soeum
        }
      }
    }
  `

  const TRANSLATIONS = {
    taeyang: '태양인',
    soyang: '소양인',
    taeum: '태음인',
    soeum: '소음인',
  }

  export default {
    props: ['showQuestions'],
    emits: ['body-type-calculated'],
    data() {
      return {
        finalType: '',
        step: 0,
        answers: [],
        questions: [],
      }
    },
    async created() {
      try {
        const res = await client.request(GET_SASANG_MUNJIN_QUERY)
        this.questions = res.getSasangMunjin
      } catch (err) {
        console.error('문진 항목 로딩 실패:', err)
      }
    },
    methods: {
      async answer(isYes) {
        if (!this.showQuestions || this.step >= this.questions.length) return
        this.answers.push(isYes)

        if (this.step === this.questions.length - 1) {
          await this.calculateResult()
        } else {
          this.step++
        }
      },
      async calculateResult() {
        try {
          const variables = { input: { answers: this.answers } }
          const res = await client.request(
            ANALYZE_SASANG_RESULT_MUTATION,
            variables,
          )
          const { sasang, tie } = res.analyzeSasangResult
          if (sasang && sasang != '중복') {
            this.finalType = TRANSLATIONS[sasang] || sasang
          } else if (tie && tie.length >= 2) {
            this.finalType = `${TRANSLATIONS[tie[0]] || tie[0]}(${TRANSLATIONS[tie[1]] || tie[1]})`
          } else {
            this.finalType = '결과 없음'
          }
          this.$emit('body-type-calculated', this.finalType)
        } catch (err) {
          console.error('체질 분석 오류:', err.message)
          this.finalType = '분석 실패'
        }
      },
    },
    computed: {
      questionText() {
        if (!this.questions.length) return ''
        return `${this.questions[this.step]?.question || ''} (${this.step + 1}/${this.questions.length})`
      },
      translatedType() {
        return this.finalType
      },
    },
  }
</script>

<style scoped>
  /* body-type-container 스타일 */
  .body-type-container {
    background-color: white;
    width: 100%;
  }

  /* 질문 박스 스타일 */
  .question-box {
    flex-direction: column;
    background: white;
    padding: 1.5rem;
    border-radius: 12px;
    border: 1px solid #ccc; /* 실선 테두리 추가 */
    /*box-shadow: 0 0 2px rgba(0, 0, 0, 0.303);*/ /* 그림자 효과 제거 */
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  /* 질문 텍스트 스타일 */
  .question {
    font-size: var(--font-size-09); /* 폰트 크기 수정 */
    margin-bottom: 1rem;
    word-break: break-word;
    text-align: left;
    margin-top: 0.33rem;
  }

  /* 버튼 그룹 스타일 */
  .button-group {
    display: flex;
    gap: 1rem;
  }
  .next-button {
    display: inline-block;
    width: 45%;
    height: 2.2rem;
    font-size: var(--font-size-09); /* 폰트 크기 수정 */
  }

  .result {
    font-size: var(--font-size-10); /* 폰트 크기 수정 */
    font-weight: bold;
  }

  .result-text {
    font-size: var(--font-size-10);
    margin-bottom: 1rem;
  }
</style>
